import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useLanguage } from '../../../contexts/LanguageContext';
import VehicleTrainingMatchForm from './components/VehicleTrainingMatchForm';
import VehicleTrainingMatchTable from './components/VehicleTrainingMatchTable';
import useVehicleTrainingMatchData from './hook/useVehicleTrainingMatchData';
import { useLmsPermission } from '../hooks/useLmsPermission';
import { LMS } from '../../../constants/permissionCodes';

const VehicleTrainingMatchPage = () => {
    const { th } = useLanguage();
    const data = useVehicleTrainingMatchData();
    const { can } = useLmsPermission();

    return (
        <div className="card">
            <ConfirmDialog />

            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleTrainingMatch.title')}</h1>

                {can(LMS.TRAINING_CREATE) && (
                    <Button
                        label={th('lmsLookupDefinitions.newButton')}
                        icon="pi pi-plus"
                        onClick={data.openDialog}
                    />
                )}
            </div>

            <VehicleTrainingMatchTable
                items={data.items}
                totalCount={data.totalCount}
                lazyParams={data.lazyParams}
                filters={data.filters}
                sortField={data.sortField}
                sortOrder={data.sortOrder}
                loading={data.isFetching}
                onPage={data.onPage}
                onFilter={data.onFilter}
                onSort={data.onSort}
                onEdit={data.openEditDialog}
            />

            <VehicleTrainingMatchForm
                visible={data.dialogVisible}
                onHide={data.closeDialog}
                formik={data.formik}
                loading={data.isCreating || data.isUpdating}
                selectedMatch={data.selectedMatch}
                deleting={data.isDeleting}
                onDelete={can(LMS.TRAINING_DELETE) ? data.removeMatch : undefined}
                readOnly={!!data.selectedMatch?.id && !can(LMS.TRAINING_UPDATE)}
            />
        </div>
    );
};

export default VehicleTrainingMatchPage;